"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Nov 09 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * InternalProductPricesDTOConverter
 *
 * @author RV
 */


var InternalProductPricesDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(InternalProductPricesDTOConverter, _DataObjectConverter_);

  function InternalProductPricesDTOConverter() {
    _classCallCheck(this, InternalProductPricesDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(InternalProductPricesDTOConverter).apply(this, arguments));
  }

  return InternalProductPricesDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.InternalProductPricesDTOConverter = InternalProductPricesDTOConverter;